import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { BrandLogo } from '../components/BrandLogo';
import { User } from 'lucide-react';

export default function ClinicianList() {
  const [clinicians, setClinicians] = useState([]);
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get('/clinicians/public').then(r => setClinicians(r.data));
    api.get('/clinic/settings').then(r => setSettings(r.data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-surface">
      <header className="border-b border-soft px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/"><BrandLogo size={48} src={settings?.clinic_logo_url || '/logo.jpg'}/></Link>
        <Link to="/login" className="text-sm text-fg-muted hover:text-brand">Sign in →</Link>
      </header>
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12">
        <div className="text-xs uppercase tracking-[0.2em] text-accent font-medium mb-2">OUR TEAM</div>
        <h1 className="text-3xl md:text-5xl font-heading font-bold tracking-tight">Meet our physiotherapists</h1>
        <p className="text-fg-muted mt-3 max-w-2xl">Pick the therapist that fits your goals. Each profile shows specialties, languages, and the next free slot.</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {clinicians.map(c => (
            <Link key={c.user_id} to={`/p/${c.slug}`}
                  className="surface border border-soft rounded-xl p-6 hover:border-brand transition flex flex-col items-center text-center gap-3"
                  data-testid={`pub-clinician-${c.user_id}`}>
              <div className="w-24 h-24 rounded-full bg-brand/10 flex items-center justify-center text-brand mx-auto">
                {c.photo_url
                  ? <img src={c.photo_url} alt="" className="w-24 h-24 rounded-full object-cover"/>
                  : <User className="w-10 h-10"/>}
              </div>
              <div>
                <div className="font-heading font-semibold">{c.name}</div>
                <div className="text-xs text-fg-muted mt-0.5">{c.credentials || 'Physiotherapist'}</div>
              </div>
              {c.bio && <p className="text-sm text-fg-muted line-clamp-3">{c.bio}</p>}
              <span className="text-xs text-brand mt-auto">View profile →</span>
            </Link>
          ))}
          {!clinicians.length && (
            <div className="col-span-full text-center text-fg-muted py-12">No clinicians published yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}
